import React from 'react';
import { Outlet } from 'react-router-dom';

import './Send.scss';

const Send = () => {
	return (
		<div className='Send'>
			<Outlet />
		</div>
	);
};

export default Send;
